<script lang="ts">
import { LOG_CODE } from '@/app/const';
import { ComplaintActivityLog } from '@/interface/Complaint.interface';
import CommonService from '@/services/commonService';
import { complaintService } from '@/services/serviceProvider';
import { useI18n } from 'vue-i18n';

export default {
    setup() {
        const { t } = useI18n();
        const commonSv = new CommonService(t);

        return { commonSv }
    },
    props: {
        modelValue: {
            type: Array<Object>,
            default: [],
        },
        groupDpmCode: {
            type: String,
            default: undefined
        },
        startDate: {
            type: Date,
            default: undefined
        },
        endDate: {
            type: Date,
            default: undefined
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            rules: {
                required: (message: any) => {
                    return (v: any) => !!v || message;
                },
            },
        }
    },
    computed: {
        model: {
            get() {
                return this.modelValue as ComplaintActivityLog[];
            },
            set(newValue: any) {
                this.$emit('update:modelValue', newValue);
            }
        },
    },
    methods: {
        dateString(date: Date | undefined) {
            return complaintService.dateTimeString(date);
        },
        decodeLog(detail: string) {
            for (const [key, value] of Object.entries(LOG_CODE)) {
                if (detail.includes(value)) {
                    const translate = this.$t(`t-log-${value.replace('{', '').replace('}', '')}`);
                    detail = detail.replace(value, translate);
                }
            }
            return detail;
        },
        durationText(index: number, date: Date | undefined) {
            let a = this.model[index - 1];
            if (a && a.createDate && date)
                return this.commonSv.durations(a.createDate, date);
            return '';
        }
    }
}
</script>
<template>
    <v-row :class="!groupDpmCode ? 'mb-4' : ''">
        <v-col v-for="(h, index) in model" cols="12">
            <div class="d-flex align-start w-100">
                <v-avatar class="mr-2 active" :color="h.departmentCode === groupDpmCode ? 'blue' : 'primary'">
                    <span v-if="h.departmentCode">{{ h.departmentCode.toUpperCase() }}</span>
                    <span v-else>{{ h.createBy?.substring(0, 2).toUpperCase() }}</span>
                </v-avatar>
                <v-card class="inner-card shadow-bottom w-100 py-2 mb-0">
                    <v-card-text>
                        <div class="d-flex align-start justify-space-between mb-3">
                            <div class="d-flex align-start mr-2">
                                <span class="mr-2" style="min-width: fit-content;">{{ dateString(h.createDate) }}</span>
                                <span>{{ decodeLog(h.detail) }}</span>
                            </div>
                            <!-- <div class="d-flex align-center">
                                <span class="mr-2">{{ h.createByName }}</span>
                                <span v-if="h.departmentCode" class="dotted">
                                    {{ $t('t-department') }} {{ h.departmentCode }}
                                </span>
                            </div> -->
                        </div>
                        <div class="d-flex align-center mb-1" style="color:darkgray">
                            <span class="mr-2">{{ $t('t-action-history-by') }} {{ h.createByName }}</span>
                            <span v-if="h.departmentCode" class="dotted">
                                {{ $t('t-department') }} {{ h.departmentCode }}
                            </span>
                        </div>
                        <div v-if="index > 0" class="d-flex align-center" style="color:cadetblue">
                            <span class="mr-2">{{ $t('t-action-history-duration') }}</span>
                            <span>{{ durationText(index, h.createDate) }}</span>
                        </div>
                        <div v-else-if="index === model.length - 1 && !groupDpmCode
                            && startDate && endDate" style="color:cadetblue;">
                            <span class="mr-2">{{ $t('t-action-history-duration-all') }}</span>
                            <span>{{ commonSv.durations(startDate, endDate) }}</span>
                        </div>
                    </v-card-text>
                </v-card>
            </div>
        </v-col>
    </v-row>
</template>